module.exports = __webpack_public_path__ + "img/电信金牌服务商.02034c55.jpg";